export default "https://cdn-static.gokick.com/assets/faf4ec4796b5499b7477edf17656e3681d9dd642/images/tangerine-flavor.f6541269ddee78b301b9a4e8b180b6f6.png";